import React from 'react';
import Form from '../../../components/molecules/Form/Form';
import IForm from '../../../types/IForm';
import { AppLibraryAddOrUpdateFormTemplate } from './AppLibraryAddOrUpdateFormTemplate';
import { getImageFromForm } from '../../../_lib/components/ImageUpload/PreviewWithCropper';

type AppLibraryAddOrUpdateFormProps = {
  form: IForm;
  refresh(): void;
};

export function AppLibraryAddOrUpdateForm({ form, refresh }: AppLibraryAddOrUpdateFormProps) {
  return (
    <Form id="app-library-add-or-update-form" model={form} onSuccess={refresh}>
      <AppLibraryAddOrUpdateFormTemplate initialImage={getImageFromForm(form)} />
    </Form>
  );
}
